import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-session-expire',
  templateUrl: './session-expire.component.html',
  styleUrls: ['./session-expire.component.scss']
})
export class SessionExpireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
